import { GTDCredentials } from '../interfaces/GTDCredentials';
import axios, { AxiosResponse } from 'axios';

const IMMAP_URL = '/api/v1/immap';

export const ImmapApi = {
	async fetchCredentials(): Promise<GTDCredentials> {
		return axios
			.get(`${IMMAP_URL}/account`)
			.then(response => response.data.data ?? null)
			.catch(error => {
				console.error('error', error);
			});
	},

	async saveCredentials(credentials: GTDCredentials): Promise<void> {
		axios.post(`${IMMAP_URL}/account`, credentials).catch(error => {
			console.error('error', error);
		});
	},

	async createProcess(processId: string, isAudit: boolean = false): Promise<AxiosResponse> {
		return axios
			.post(`${IMMAP_URL}/process/${processId}?audit=${isAudit ? 'T' : 'F'}`, null)
			.then(response => response.data)
			.catch(error => error.response);
	},
};
